module.exports = __webpack_public_path__ + "img/a.c0abed20.png";